// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__3deu2","modal":"Modal_modal__2ALus","slide-down":"Modal_slide-down__1oeZe"};